import { render, staticRenderFns } from "./404.vue?vue&type=template&id=2ad90d74&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=2ad90d74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad90d74",
  null
  
)

export default component.exports